import React from 'react';

import CustomButton from 'components/partials/custom-button/custom-button';

import Icons from 'assets/icons';

const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-12';

export const getCriticalElementsTableSettings = (handleViewDetails) => [
  {
    id: 'summary',
    accessorKey: 'summary',
    header: () => <span>CRITICAL ELEMENT</span>,
    cell: (info) => <span>{info.renderValue()}</span>,
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'pl-4 py-3 tablet:w-[30%] font-semibold',
    enableSorting: false,
  },
  {
    id: 'relatedGoals',
    accessorKey: 'goals',
    header: () => <span>RELATED GOALS</span>,
    cell: (info) => {
      const goals = info.getValue() || [];

      if (goals.length === 0) {
        return <span className="w-full text-gray-04">No goals linked</span>;
      }

      return (
        <div className="flex flex-wrap gap-2">
          {goals.map(
            (goal, index) =>
              goal.summary && (
                <div
                  key={index}
                  className="inline-block px-2 leading-5 py-1 rounded-md text-sm text-gray-03 border border-gray-05"
                >
                  {goal.summary}
                </div>
              )
          )}
        </div>
      );
    },
    headerClassName: `${commonStyles}`,
    className: 'pl-4 py-3 tablet:w-[45%]',
    enableSorting: false,
  },
  {
    id: 'actions',
    accessorKey: 'id',
    header: () => <span>ACTION</span>,
    isHeaderCentered: true,
    cell: (info) => (
      <div className="flex justify-center">
        <CustomButton
          variant="secondary"
          size="sm"
          iconBefore={<Icons.Eye alt="EyeIcon" height="100%" width="14" />}
          customClass="text-xs md:text-sm"
          onClick={() => handleViewDetails(info.getValue())}
        >
          View Details
        </CustomButton>
      </div>
    ),
    headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
    className: 'pl-4 py-3 tablet:w-[15%]',
    enableSorting: false,
  },
];
